import { useSetAtom } from "jotai";
import { signUpDataAtom, resetSignUpData } from "store/signUpStore";
import { APP_TO_WEB } from "common/webview";
import { parseSnsPhone } from "utils/snsPhone";
import { getActiveBackHandler } from "./useBackInterceptor";
import { useQuery } from "./useQuery";

export const useWebviewMessage = () => {
    const setSignUpData = useSetAtom(signUpDataAtom);
    const resetSignUp = useSetAtom(resetSignUpData);
    const { navigate } = useQuery();

    return (type: string, data: any) => {
        switch (type) {
            case APP_TO_WEB.SOCIAL_FAILED: {
                resetSignUp();

                // 전화번호 분해.
                //   신버전 앱: ctnRaw(SNS 원본 E.164)를 보내므로 웹에서 파싱 — 파싱 규칙이 웹 한 곳에만 존재해
                //   IdentityGlobalPhoneForm.buildCtn 과 형식이 어긋날 수 없다.
                //   구버전 앱: ctnRaw 가 없고 앱이 자체 파싱한 ctn/ctnCountryCd 를 보낸다 → 그대로 사용(기존 동작).
                //   앱 업데이트가 충분히 퍼지면 else 분기는 제거 가능.
                const phone = data.ctnRaw
                    ? parseSnsPhone(data.ctnRaw)
                    : {
                        ctn: data.ctn?.replace(/-/g, "") || "",
                        ctnCountryCd: data.ctnCountryCd || "",
                        ctnCountry: "" as const,
                    };

                setSignUpData(prev => ({
                    ...prev,
                    snsLogin: data.provider !== "EMAIL",
                    provider: data.provider || "EMAIL",
                    providerUserId: data.providerUserId || "",
                    ctn: phone.ctn,
                    ctnCountryCd: phone.ctnCountryCd,
                    ctnCountry: phone.ctnCountry,
                    birth: data.birth || "",
                    gender: data.gender || "",
                    nickname: data.nickname || "",
                    email: data.email || "",
                    name: data.name || "",
                    // SNS 프로필 이미지 URL — Step6 에서 미리보기 후 사용 여부를 사용자가 선택한다.
                    snsProfileImgUrl: data.profileImgUrl || "",
                    useSnsProfileImg: true,
                    snsProvidedFields: {
                        birth: !!data.birth,
                        gender: !!data.gender,
                        name: !!data.name,
                        email: !!data.email,
                        // 파싱 실패한 원본은 prefill 대상이 아니다 (ctn 이 빈 값).
                        ctn: !!phone.ctn,
                    },
                }));
                navigate("/sign-up");
                break;
            }
            case APP_TO_WEB.PRESS_BACK: {
                const handler = getActiveBackHandler();
                if (handler) handler();
                else window.history.back();
                break;
            }
            default:
                break;
        }
    };
};
